// Ensure ThreeJS is in global scope for the 'examples/'
global.THREE = require("three");

// Include any additional ThreeJS examples below
require("three/examples/js/controls/OrbitControls");

const canvasSketch = require("canvas-sketch");
const glsl = require('glslify');
const palettes = require('nice-color-palettes');
const random = require('canvas-sketch-util/random');
const chroma = require('chroma-js');
const { Points } = require("three");

console.log(random.getRandomSeed());

const TWO_PI = Math.PI * 2.;
const palette = random.pick(palettes);
const cubePalette = palette.slice(2,4);

const pink = chroma('hotpink').hex();

let f = chroma.scale([random.pick(palette), random.pick(cubePalette)]).mode('lab');
let f2 = chroma.scale([random.pick(palette), random.pick(cubePalette)]).mode('lab');
// console.log(f(0.5).hex());
// const color 


// console.log(pink);
// console.log(random.pick(palette));

const settings = {
  // Make the loop animated
  animate: true,
  duration: 8,
  
  fps: 24,
  // Get a WebGL canvas rather than 2D
  context: "webgl"
};

const sketch = ({ context }) => {
  // Create a renderer
  const renderer = new THREE.WebGLRenderer({
    canvas: context.canvas
  });

  // WebGL background color
  renderer.setClearColor(random.pick(palette), 0.4);

  

  // Setup a camera
  const camera = new THREE.PerspectiveCamera(50, 1, 0.01, 100);
  camera.position.set(0, 0, -5);
  camera.lookAt(new THREE.Vector3());

  // Setup camera controller
  const controls = new THREE.OrbitControls(camera, context.canvas);

  // Setup your scene
  const scene = new THREE.Scene();

  // Setup a geometry
  const geometry = new THREE.SphereBufferGeometry(1, 200,200);

  // const dots = new THREE.IcosahedronGeometry(1,1);
  const dots = new THREE.BoxGeometry(1, 1,1,5,5,5);
  const points = dots.vertices;

  // console.log(dots.vertices);

  const vert = glsl(["#define GLSLIFY 1\n\n    varying vec3 vNormal;\n    varying vec2 vUv;\n    varying vec3 vPosition;\n\n    uniform float time;\n    uniform float stretch;\n    uniform float stretchfreq;\n    uniform vec3 points [POINT_COUNT];\n\n    \n\n    void main () {\n      vPosition = position;\n      vUv = uv;\n      vNormal = normal;\n      vec3 pos = position;\n      vec3 transformed = position.xyz;\n      //  pos.x = pos.x + 0.5*sin(2.*pos.x + time);\n      //  pos.y = pos.y + 0.1*sin(10.*pos.x + time);\n      // pos.z = pos.z + 0.5*sin(10.*pos.x + time);\n      // pos.z = pos.z + 0.1*sin(10.*pos.y + time);\n      //  transformed.yz *= sin(stretchfreq*position.y + stretch + time);\n      // transformed.yz *= sin(stretchfreq*2.*position.x + stretch);\n\n      gl_Position = projectionMatrix * modelViewMatrix * vec4(pos+transformed, 1.0);\n}\n    "]);

  const frag = glsl(["#define GLSLIFY 1\n\n    //\n// Description : Array and textureless GLSL 2D/3D/4D simplex\n//               noise functions.\n//      Author : Ian McEwan, Ashima Arts.\n//  Maintainer : ijm\n//     Lastmod : 20110822 (ijm)\n//     License : Copyright (C) 2011 Ashima Arts. All rights reserved.\n//               Distributed under the MIT License. See LICENSE file.\n//               https://github.com/ashima/webgl-noise\n//\n\nvec3 mod289(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289(vec4 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute(vec4 x) {\n     return mod289(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt(vec4 r)\n{\n  return 1.79284291400159 - 0.85373472095314 * r;\n}\n\nfloat snoise(vec3 v)\n  {\n  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;\n  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);\n\n// First corner\n  vec3 i  = floor(v + dot(v, C.yyy) );\n  vec3 x0 =   v - i + dot(i, C.xxx) ;\n\n// Other corners\n  vec3 g = step(x0.yzx, x0.xyz);\n  vec3 l = 1.0 - g;\n  vec3 i1 = min( g.xyz, l.zxy );\n  vec3 i2 = max( g.xyz, l.zxy );\n\n  //   x0 = x0 - 0.0 + 0.0 * C.xxx;\n  //   x1 = x0 - i1  + 1.0 * C.xxx;\n  //   x2 = x0 - i2  + 2.0 * C.xxx;\n  //   x3 = x0 - 1.0 + 3.0 * C.xxx;\n  vec3 x1 = x0 - i1 + C.xxx;\n  vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y\n  vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y\n\n// Permutations\n  i = mod289(i);\n  vec4 p = permute( permute( permute(\n             i.z + vec4(0.0, i1.z, i2.z, 1.0 ))\n           + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))\n           + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));\n\n// Gradients: 7x7 points over a square, mapped onto an octahedron.\n// The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)\n  float n_ = 0.142857142857; // 1.0/7.0\n  vec3  ns = n_ * D.wyz - D.xzx;\n\n  vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)\n\n  vec4 x_ = floor(j * ns.z);\n  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)\n\n  vec4 x = x_ *ns.x + ns.yyyy;\n  vec4 y = y_ *ns.x + ns.yyyy;\n  vec4 h = 1.0 - abs(x) - abs(y);\n\n  vec4 b0 = vec4( x.xy, y.xy );\n  vec4 b1 = vec4( x.zw, y.zw );\n\n  //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;\n  //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;\n  vec4 s0 = floor(b0)*2.0 + 1.0;\n  vec4 s1 = floor(b1)*2.0 + 1.0;\n  vec4 sh = -step(h, vec4(0.0));\n\n  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;\n  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;\n\n  vec3 p0 = vec3(a0.xy,h.x);\n  vec3 p1 = vec3(a0.zw,h.y);\n  vec3 p2 = vec3(a1.xy,h.z);\n  vec3 p3 = vec3(a1.zw,h.w);\n\n//Normalise gradients\n  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));\n  p0 *= norm.x;\n  p1 *= norm.y;\n  p2 *= norm.z;\n  p3 *= norm.w;\n\n// Mix final noise value\n  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);\n  m = m * m;\n  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1),\n                                dot(p2,x2), dot(p3,x3) ) );\n  }\n\n    float aastep(float threshold, float value) {\n  #ifdef GL_OES_standard_derivatives\n    float afwidth = length(vec2(dFdx(value), dFdy(value))) * 0.70710678118654757;\n    return smoothstep(threshold-afwidth, threshold+afwidth, value);\n  #else\n    return step(threshold, value);\n  #endif  \n}\n\n    varying vec2 vUv;\n    varying vec3 vPosition;\n    varying vec3 vNormal;\n\n    uniform vec3 color;\n    uniform vec3 color2;\n    uniform float time;\n    uniform vec3 points [POINT_COUNT];\n\n    uniform mat4 modelMatrix;\n\n    float sphereRim (vec3 spherePosition) {\n      vec3 normal = normalize(spherePosition.xyz);\n      vec3 worldNormal = normalize(mat3(modelMatrix) * normal.xyz);\n      vec3 worldPosition = (modelMatrix * vec4(spherePosition, 1.0)).xyz;\n      vec3 V = normalize(cameraPosition - worldPosition);\n      float rim = 1.0 - max(dot(V, worldNormal), 0.0);\n      return pow(smoothstep(0.0, 1.0, rim), 0.5);\n    }\n\n    void main () {\n      float rim = sphereRim(vPosition);\n      float dist = 100000.0;\n      float n = 0.;\n      for ( int i = 0; i < POINT_COUNT; i++){\n        vec3 p = points[i];\n        float d = distance(vPosition, p);\n        \n        dist = min(d, dist);\n      }\n      n = snoise(vPosition + time )*0.1;\n      //float mask = smoothstep(0.1,0.12, dist+n);\n      // float mask = aastep(0.1, 0.2*sin(200.*dist+20.*fract(time)));\n      float mask = aastep(0.1, 0.2*sin(70.*dist+20.*fract(time*.05)));\n      mask = 1.0 - mask;\n\n      vec3 fragColor = mix(color, vec3(0.,0.,0.), mask);\n      //fragColor /= mix(color, vec3(0.,0.,0.), mask/mask);\n      fragColor += rim * 0.6;\n      gl_FragColor = vec4(vec3(fragColor), 1.0);\n\n      // to discard the mask\n       if (mask > 0.5) discard;\n    }\n    "]);

  // Setup a material
  const material = new THREE.ShaderMaterial({
    fragmentShader : frag,
    vertexShader : vert,
    extensions: {
      derivatives: "#extension GL_OES_standard_derivatives : enable"
    },
    defines : {
      POINT_COUNT : points.length
    },
    uniforms : {
      points: {value: points},
      color : {value : new THREE.Color(f(0.3).hex())}, 
      color2 : {value : new THREE.Color(f(0.1).hex())}, 
      time : {value : 0},
      stretch : {value : 0},
      stretchfreq : {value : 0},
      
    //   wireframe: true
    },
    side: THREE.DoubleSide,
     
  });

  

  // Setup a mesh with geometry + material
  const mesh = new THREE.Mesh(geometry, material);
  // mesh.rotateY(Math.PI/4)
  // mesh.rotateX(Math.PI/3)
  scene.add(mesh);

  

//   const light = new THREE.DirectionalLight('0xffffff');
//   light.position.set(1,1,-1);
//   scene.add(light);
  // draw each frame
  return {
    // Handle resize events here
    resize({ pixelRatio, viewportWidth, viewportHeight }) {
      renderer.setPixelRatio(pixelRatio);
      renderer.setSize(viewportWidth, viewportHeight, false);
      camera.aspect = viewportWidth / viewportHeight;
      camera.updateProjectionMatrix();
    },
    // Update & render your scene here
    render({ time,playhead }) {
    //   let timer = Date.now();
    //   console.log(timer);
      //mesh.rotation.y += Math.PI ;
      mesh.rotation.y = playhead * TWO_PI;
      mesh.rotation.x = -playhead * TWO_PI;

      controls.update();
      renderer.render(scene, camera);
      mesh.material.uniforms.time.value = playhead *TWO_PI;
      mesh.material.uniforms.stretch.value = playhead *TWO_PI;
      mesh.material.uniforms.stretchfreq.value = playhead *TWO_PI *50.*Math.sin(playhead*TWO_PI);
      mesh.material.uniforms.color.value = new THREE.Color(f(Math.abs(Math.sin(playhead*TWO_PI))).hex())
      mesh.material.uniforms.color2.value = new THREE.Color(f2(Math.abs(Math.sin(playhead*TWO_PI))).hex())
    },
    // Dispose of events & renderer for cleaner hot-reloading
    unload() {
      controls.dispose();
      renderer.dispose();
    }
  };
};

canvasSketch(sketch, settings);
